define('models/supplySource',["T1", "T1Model", "Backbone"], function (T1, T1Model, Backbone) {
  T1.Models.SupplySource = T1Model.extend({
    url: "supply_sources/",
    fixture: "-supplySource"
  });
  return T1.Models.SupplySource;
});
